export const WAREHOUSE_DIALOG_IDS = {
  bulkAssignMechanicDialog: 'bulk-assign-mechanic-dialog',
};
